import React, { useEffect, useState } from "react";
import ChainCard from "./ChainCard";
import ProjectSelectModal from "./ProjectSelectModal";
import { useDispatch, useSelector } from "react-redux";
import { fetchChainProjects, fetchLoggedUserChains } from "state/logged_user_chains";
import { State } from "state";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { Chain } from "interfaces/chain";

const AssociatedChains: React.FC<RouteComponentProps> = ({ history }) => {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedChain, setSelectedChain] = useState<Chain | null>(null);

  const {
    loading,
    content: chains,
    error,
    projectsLoading,
    projectsError,
    chainProjects,
  } = useSelector((state: State) => state.logged_user_chains);

  useEffect(() => {
    dispatch(fetchLoggedUserChains());
  }, [dispatch]);

  const handleClose = () => {
    setIsModalOpen(false);
    setSelectedChain(null);
  };

  const handleChainClick = (chain: Chain) => {
    setSelectedChain(chain);
    dispatch(fetchChainProjects(chain.id));
    setIsModalOpen(true);
  };

  const styles = {
    section: {
      // backgroundColor: "#fff",
      borderRadius: "1rem",
      // boxShadow: "0 4px 4px rgba(0,0,0,0.1)",
      // padding: "1.5rem",
      width: "100%",
     // maxWidth: "80rem",
      // margin: "0 auto",
      display: "flex",
      flexDirection: "column",
      alignItems: "start",
      gap: "1.5rem",
      // border: "1px solid #F0F2F5",
    } as React.CSSProperties,
    heading: {
      fontSize: "1.125rem",
      marginBottom: ".6rem",
    } as React.CSSProperties,
    chainsContainer: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "flex-start",
      gap: "1.5rem",
    } as React.CSSProperties,
  };
  const sortedChains = chains
  ? [...chains].sort((a, b) => a.name.localeCompare(b.name))
  : [];

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error fetching chains</p>;

  return (
    <section style={styles.section}>
      <h2>Select a Chain Below to View its Project</h2>

      <div style={styles.chainsContainer}>
        {sortedChains?.map((chain) => (
          <ChainCard
            key={chain.id}
            id={chain.id}
            name={chain.name}
            logo={chain.logo}
            logo_filename={(chain as any).logo_filename}
            onClick={() => handleChainClick(chain)}
          />
        ))}

        {(chains === undefined || (chains && chains.length == 0)) && (
          <p style={{color: "grey"}}>User has not been assigned to any Chain</p>
        )}
      </div>

      <ProjectSelectModal
        open={isModalOpen}
        onClose={handleClose}
        projects={chainProjects}
        projectsLoading={projectsLoading}
        projectsError={projectsError}
        chainName={selectedChain}
        onSelectProject={(project) => {
          handleClose();
        }}
      />
    </section>
  );
};

export default withRouter(AssociatedChains);
